<template>
  <vs-popup class="ini_preview" :title="title" :active.sync="addNewDataLocal">
    <div class="p-2 text-center">
      <label>Choose Geofence</label>
      <div
        style="margin: auto"
        class="vs-component vs-con-input-label vs-input mt-1 mb-1 vs-input-primary">
        <!--<label class="vs-input&#45;&#45;label">Type</label>-->
        <v-select
          placeholder="- Select Fleet Group -"
          style="background: white"
          @input="(x) => (selectedGeofence = x)"
          :clearable="false"
          :value="getSelectValue(selectedGeofence, listGeofence)"
          :reduce="(text) => text.value"
          label="geofence_name"
          :options="listGeofence" />
      </div>
      <!--<vs-select style="margin: auto" autocomplete v-model="selectedGeofence" placeholder="- Select Fleet Group -" class="mt-1 mb-1">-->
      <!--<vs-select-item  :key="item.id" :value="item" :text="item.geofence_name" v-for="item in listGeofence" />-->
      <!--</vs-select>-->
    </div>
    <vs-list>
      <!--<draggable :list="listPaired" group="people" class="p-2 cursor-move">-->
      <!--</draggable>-->
    </vs-list>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'
import GeofeceData from './GeofenceViewData.vue'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    geoType: String,
    allData: Array,
    dataCoordinate: Array,
    alertData: Array,
    geoName: String,
    listGeofence: Array,
    fleetGroupData: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  components: {
    GeofeceData,
  },
  watch: {
    selectedGeofence(val) {
      //
      this.$router.push('/master-data/geofence-mapping-view/' + val._id)
      this.$emit('changeModal')

      setTimeout(() => {
        // this.$router.go('/master-data/geofence-mapping-view/'+val.id)
      }, 200)
      setTimeout(() => {
        // this.$router.push('/master-data/geofence-mapping-view/'+val.id)
      }, 200)
    },
    editMode(val) {
      if (val) {
        // this.s_alert = this.dataEdit.alert_id;
        // this.calculateFleetEdit(this.s_alert);
        // this.fleetGroup = this.dataEdit.fleet_group_id;
        //
      } else {
        //
      }
    },
    s_alert(val) {
      this.calculateFleet(val)
    },
  },
  mounted() {
    //
  },
  computed: {
    addNewDataLocal: {
      get() {
        if (this.addNewData) {
          this.dataCoor = this.dataCoordinate
        } else {
          this.dataCoor = []
        }
        return JSON.parse(this.addNewData)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      alert_array: [],
      fleet_array: [],
      s_alert: '',
      selectedGeofence: '',
      dataCoor: [],
      fleetGroup: '',
    }
  },
  methods: {
    clickEdit() {
      //
      this.$emit('closeModal')
    },
  },
}
</script>
<style>
.ini_preview > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;

  overflow: visible !important;
}
</style>
